import { render } from "./SearchIcon16.vue.js?vue&type=template&id=3a24e1ca!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./SearchIcon16.vue?vue&type=template&id=3a24e1ca"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__